import { useState } from "react"
import classNames from "classnames"
import moment from "moment"

import { useTranslation } from "lib/i18n/translation"
import { manageTechnicals, mapPeople } from "lib/tools/product"

export const CreditsDatasheet = ({ product, details, loading }) => {
	const { c } = useTranslation("common")

	const [extras, setExtras] = useState(false)

	const technicals = manageTechnicals(details)

	return (
		<>
			<a
				href="#"
				onClick={e => {
					e.preventDefault()
					setExtras(!extras)
				}}
				title={c("show-datasheet")}
				rel="nofollow noopener"
				className={classNames(
					"collapsible-toggle icon-clipboard button",
					{
						"skeleton": loading
					}
				)}
			>
				{c("credits-and-datasheet")}
			</a>
			<div
				className={classNames(
					"collapsible",
					{
						"skeleton": loading,
						"active": extras
					}
				)}
			>
				<ul className="casting columns">
					<li>
						<h2>{c("credits")}</h2>
						{details && (
							<ul className="list">
								{mapPeople(details).map((p, index) => (
									<li key={`credits-${index}`}>
										<span>{c(p.role)} : </span>{p.people.join(', ')}
									</li>
								))}
							</ul>
						)}
					</li>
					<li>
						<h2>{c("technical-information")}</h2>
						<ul className="list">
							<li><span>{c("printed-film-format")} : </span>{technicals.support}</li>
							{!!technicals.sound && (
								<li><span>{c("original-sound-mix")} : </span>{technicals.sound}</li>
							)}
							<li><span>{c("production")} : </span>{product.year}</li>
							{!!technicals.dateFrance && (
								<li><span>{c("release-date-for-france")} : </span>{moment(technicals.dateFrance).format("D MMMM YYYY")}</li>
							)}
							<li><span>{c("category")} : </span>{technicals.filmType}</li>
							<li><span>{c("color")} : </span>{technicals.colors}</li>
							<li><span>{c("language")} : </span>{technicals.lang}</li>
							{technicals.subtitles && (
								<li><span>{c("subtitles")} : </span>{technicals.subtitles}</li>
							)}
						</ul>
					</li>
				</ul>
			</div>
		</>
	)
}
